import { SDK } from "./SDK";

const sdk = new SDK();

window.sdk = sdk;

export default sdk;
